import { createReducer } from 'reduxsauce';
import { CURRENT_USER, AUTHENTICATION, COMPANY_ONBOARDING } from 'actions/Base';

export const INITIAL_STATE = {
  instance: null,
  isLoading: false,
};

export const onGetRequest = (state) => ({ ...state, isLoading: true });
export const onGetFailure = (state) => ({ ...state, isLoading: false });
export const onGetSuccess = (state, { payload }) => ({ ...state, isLoading: false, instance: payload });

export const onSetLanguageRequest = (state) => ({ ...state, isLoading: true });
export const onSetLanguageFailure = (state) => ({ ...state, isLoading: false });
export const onSetLanguageSuccess = (state, { payload }) => ({ ...state, isLoading: false, instance: payload });

export const onSetProfilePictureRequest = (state) => ({ ...state, isLoading: true });
export const onSetProfilePictureFailure = (state) => ({ ...state, isLoading: false });
// export const onSetProfilePictureSuccess = (state) => ({ ...state, isLoading: false });
export const onSetProfilePictureSuccess = (state, { payload }) => {
  return ({ 
    ...state, 
    isLoading: false, 
    instance: { 
      ...state.instance, 
      ...payload 
    } 
  });
}

export const onCreateCompanyUserSuccess = (state, { payload }) => ({ ...state, instance: payload });

export const onResetRequest = () => INITIAL_STATE;

export const ACTION_HANDLERS = {
  [CURRENT_USER.GET_REQUEST]: onGetRequest,
  [CURRENT_USER.GET_FAILURE]: onGetFailure,
  [CURRENT_USER.GET_SUCCESS]: onGetSuccess,
  [CURRENT_USER.SET_LANGUAGE_REQUEST]: onSetLanguageRequest,
  [CURRENT_USER.SET_LANGUAGE_FAILURE]: onSetLanguageFailure,
  [CURRENT_USER.SET_LANGUAGE_SUCCESS]: onSetLanguageSuccess,
  [CURRENT_USER.SET_PROFILE_PICTURE_REQUEST]: onSetProfilePictureRequest,
  [CURRENT_USER.SET_PROFILE_PICTURE_FAILURE]: onSetProfilePictureFailure,
  [CURRENT_USER.SET_PROFILE_PICTURE_SUCCESS]: onSetProfilePictureSuccess,
  [AUTHENTICATION.RESET_REQUEST]: onResetRequest,
  [COMPANY_ONBOARDING.CREATE_COMPANY_USER_SUCCESS]: onCreateCompanyUserSuccess,
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
